function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "param(fill) #FFFFFF",
  stroke: "param(fill) #FFFFFF",
  strokeWidth: 0.5,
  fillRule: "evenodd",
  strokeLinejoin: "bevel"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11 21C5.486 21 1 16.514 1 11a9.9 9.9 0 012.14-6.183.4.4 0 01.628.496A9.105 9.105 0 001.8 11c0 5.073 4.127 9.2 9.2 9.2a9.147 9.147 0 003.453-.67.4.4 0 01.3.742A9.948 9.948 0 0111 21zM18.408 17.506a.4.4 0 01-.308-.654A9.215 9.215 0 0020.2 11c0-5.073-4.127-9.2-9.2-9.2a9.114 9.114 0 00-3.882.857.4.4 0 01-.338-.726A9.923 9.923 0 0111 1c5.514 0 10 4.486 10 10 0 2.317-.811 4.577-2.283 6.36a.4.4 0 01-.309.146z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 7.326a.4.4 0 01-.398-.356l-.205-1.863-1.855.27a.394.394 0 01-.453-.337.4.4 0 01.337-.454l2.265-.33a.403.403 0 01.455.351l.25 2.275A.401.401 0 014 7.326zM17.935 18.184a.394.394 0 01-.227-.071.395.395 0 01-.167-.264l-.37-2.259a.4.4 0 11.788-.13l.303 1.85 1.838-.368a.4.4 0 11.158.784l-2.244.45a.318.318 0 01-.079.008z"
}));

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearch;